/* eslint-disable no-new,no-unused-vars */
// import GoogleMapsLoader from 'google-maps'
import flatpickr from 'flatpickr'
// import {ImageResize} from 'quill-image-resize-module'
// import {ImageDrop} from 'quill-image-drop-module'

const _b = require('bootstrap.native/dist/bootstrap-native-v4')

class DOM {
  constructor(selector) {
    let elements = null
    if (typeof selector === 'string') {
      elements = document.querySelectorAll(selector)
    } else if (selector instanceof NodeList) {
      elements = selector
    } else {
      elements = [selector]
    }

    this.length = Object.keys(elements).length
    Object.assign(this, elements)

    // if (this.length === 0) console.error(`l'élément: %c${selector}%c est inconnu`, 'background: #222; color: #bada55', '')
  }

  /**
   * Vérifie que le dom soit chargé
   * @param callback
   * @returns {*}
   */
  ready(callback) {
    document.addEventListener('DOMContentLoaded', (event) => {
      callback(event, document, this)
    })
  }

  go() {
    return new Promise((resolve) => {
      document.addEventListener('DOMContentLoaded', (event) => {
        resolve({event, document, app: this})
      })
    })
  }

  /**
   * Renvoie le calback de chaque élément
   * @param {Function} callback
   */
  each(callback) {
    for (let el of Array.from(this)) {
      if (typeof callback === 'function') {
        callback(el)
      }
    }
    return this
  }

  html(str) {
    if (typeof str === 'string') {
      this.each(el => {
        if (typeof el !== 'undefined') {
          el.innerHTML = str
        }
      })
    } else {
      return (this.hasOwnProperty(0)) ? this[0].innerHTML : null
    }
  }

  /**
   * Ajoute un ecouteur d'événement
   * @param evenement
   * @param child
   * @param {Function} callback The function to call when the event is triggered
   */
  on(evenement, child, callback) {
    return this.each(el => {
      el.addEventListener(evenement, evt => {
        if (typeof child === 'function') {
          child(el, evt)
        } else if (typeof child === 'string') {
          let target = evt.target
          while (target && target !== el) {
            if (target.matches(child)) {
              if (typeof callback === 'function') {
                callback(target, evt)
              }
            }
          }
        } else {
          if (typeof callback === 'function') {
            callback(el, evt)
          }
        }
      }, false)
    })
  }

  /**
   * N'effectue un événement qu'une fois
   * @param event
   * @param callback
   * @returns {*}
   */
  one(event, callback) {
    return this.each(el => {
      el.addEventListener(event, el => {
        if (!el.dataset.triggered) {
          if (callback !== null && typeof callback === 'function') {
            callback(event, el)
          }
          el.dataset.triggered = 'true'
        }
      }, false)
    })
  }

  delegate(el, evt, sel, handler) {
    el.addEventListener(evt, (event) => {
      let t = event.target
      while (t && t !== this) {
        if (t.matches(sel)) {
          handler.call(t, event)
        }
        t = t.parentNode
      }
    })
  }

  /**
   * Ajoute une class à un élémnet
   * @param {String} className Nom de la class à ajouter
   */
  addClass(className) {
    return this.each(el => {
      el.className += ` ${className}`
    })
  }

  /**
   * Supprime une class d'un élément
   * @param {String} className Nom de la class à supprimer
   */
  removeClass(className) {
    return this.each(el => {
      if (el.classList.contains(className)) el.classList.remove(className)
    })
  }

  /**
   * Ajoute ou retire la class demandée
   * @param className Nom de la class
   * @returns {*}
   */
  toggleClass(className) {
    return this.each(el => {
      el.classList.toggle(className)
    })
  }

  /**
   * Vérifie que la class donnée en paramètre existe pour cet élément
   * @param className Nom de la class
   * @returns {boolean}
   */
  hasClass(className) {
    if (DOM.exist(this)) {
      return this[0].classList.contains(className)
    }
    return false
  }

  /**
   * Ajoute ou modifie des valeurs css d'un élément
   * @param attributes
   * @param value
   * @returns {*}
   */
  css(attributes, value) {
    return this.each(el => {
      if (typeof attributes === 'object') {
        for (let attr in attributes) {
          if (attributes.hasOwnProperty(attr) && el.style.hasOwnProperty(attr)) {
            el.style[attr] = attributes[attr]
          }
        }
      } else if (typeof attributes === 'string') {
        if (el.style.hasOwnProperty(attributes)) {
          el.style[attributes] = value
        }
      }
    })
  }

  /**
   * Récupère la valeur d'un input ou d'un Textarea
   * @returns {*}
   */
  val(value) {
    for (let el of Array.from(this)) {
      if (this.length > 0) {
        if (
          el &&
          (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement || el instanceof HTMLSelectElement)
        ) {

          if (value) {
            el.value = value
          } else {
            return el.value
          }
        }
      }
    }
  }

  dataset(name, value) {
    for (let el of Array.from(this)) {
      if (this.length > 0) {
        if (el && el instanceof HTMLElement) {
          if (name && !value) {
            if (el.dataset && el.dataset.hasOwnProperty(name)) {
              return el.dataset[name]
            }
          } else if (name && value) {
            if (el.dataset && el.dataset.hasOwnProperty(name)) {
              el.dataset[name] = value
            }
          } else {
            if (el.dataset) {
              return el.dataset
            }
          }
        }
      }
    }
  }

  /**
   * Récupère l'élément le plus proche
   * @returns {*}
   */
  closesets(closerElement, callback) {
    for (let el of Array.from(this)) {
      let matchesFn
      [
        'matches',
        'webkitMatchesSelector',
        'mozMatchesSelector',
        'msMatchesSelector',
        'oMatchesSelector'
      ].some(fn => {
        if (typeof document.body[fn] === 'function') {
          matchesFn = fn
          return true
        } else {
          return false
        }
      })
      let parent
      while (el) {
        parent = el.parentElement
        if (parent && parent[matchesFn](closerElement)) {
          if (callback !== null && typeof callback === 'function') {
            callback(parent)
          }
          return new DOM(parent)
        }
        el = parent
      }
    }
    return this
  }

  find(target) {
    for (let el of Array.from(this)) {
      let $target = el.querySelectorAll(target)
      if ($target) {
        return new DOM($target)
      }
    }
    return this
  }

  attr(attribute, value) {
    for (let el of Array.from(this)) {
      if (el instanceof HTMLElement) {
        if (value) {
          el.setAttribute(attribute, value)
          return this
        }
        if (el.hasAttribute(attribute)) {
          return el.getAttribute(attribute)
        }
      }
    }
    // return this
  }

  delete(className, time) {
    return new Promise(resolve => {
      this.each(el => {
        className = className ? className : 'fadeOut'
        if (el && el instanceof HTMLElement) {
          el.className += `animated ${className}`
          setTimeout(() => {
            el.remove()
            resolve()
          }, time)
        }
      })
    })
  }

  // modal (params) {
  //   return this.each(el => {
  //     let defaultOptions = {
  //       modal: '#modal-img',
  //       titre: ``,
  //       message: ``,
  //       img: ``
  //     }
  //     console.log(el)
  //     let options = Object.assign(defaultOptions, params)
  //     let modalInstance = new _b.Modal(options.modal)
  //     let modal = document.querySelector(options.modal)
  //     let image = ''
  //     if (options.image) {
  //       image = `<div class="text-center"><img src="${options.image}" class="img-fluid mx-auto"/></div>`
  //       modal.querySelector('.modal-body').innerHTML = image
  //     }
  //     modalInstance.toggle()
  //   })
  // }

  // route (route, callback) {
  //   if (document.location.href.split('/').pop() === route) {
  //     if (typeof callback === 'function') {
  //       return callback()
  //     }
  //   }
  // }

  // attributeClass (elem) {
  //   return new Promise (resolve => {
  //     elem.addClass('animated  fadeOut')
  //     resolve(true)
  //   })
  // }

  // modalForm (params) {
  //   return new Promise(resolve => {
  //     // import('bootstrap.native').then((bs, c, d, e) => {
  //       let defaultOptions = {
  //         modal: '#modal-attention',
  //         btnConfirm: '#delete-confirmation',
  //         titre: 'Attention',
  //         message: `Êtes vous sûr de vouloir supprimer cet élément ?`
  //       }
  //       let options = Object.assign(defaultOptions, params)
  //       let modalInstance = new _b.Modal(options.modal)
  //       if (options.btnConfirm === null) {
  //         options.btnConfirm = '#delete-confirmation'
  //       }
  //       let modal = document.querySelector(options.modal)
  //       modal.querySelector('.modal-title').innerHTML = options.titre
  //       modal.querySelector('.modal-body').innerHTML = options.message
  //       modalInstance.show()
  //       let confirmBtn = modal.querySelector(options.btnConfirm)
  //       confirmBtn.removeEventListener('click', {passive: true})
  //       confirmBtn.addEventListener('click', (evt) => {
  //         evt.stopPropagation()
  //         evt.preventDefault()
  //         resolve(true)
  //         modalInstance.hide()
  //       })
  //     // })
  //   })
  // }

  /**
   * Verifie l'existence d'un element
   * @returns {boolean}
   */
  isset() {
    return this !== null && this.length > 0
  }

  static getAttribute(el, attribute) {
    if (el !== null && el.length > 0) {
      return el.getAttribute(attribute)
    }
  }

  // gmap (map, marker, autocomplete, callback) {
  //   const settings = require('@base/settings')
  //   return this.each(el => {
  //     import('google-maps').then(GoogleMapsLoader => {
  //       GoogleMapsLoader.KEY = settings.gmap.key
  //       GoogleMapsLoader.LANGUAGE = 'fr'
  //       GoogleMapsLoader.LIBRARIES = ['geometry', 'places']
  //       GoogleMapsLoader.load(google => {
  //         let _map = new google.maps.Map(el, map)
  //         let $marker = {
  //           position: {lat: map.center.lat, lng: map.center.lng},
  //           map: _map
  //         }
  //         $marker = !marker ? $marker : Object.assign($marker, marker)
  //         let _marker = new google.maps.Marker($marker)
  //         let _autocomplete = null
  //         if (autocomplete) {
  //           if (typeof autocomplete === 'string') {
  //             autocomplete = document.querySelector(autocomplete)
  //           }
  //           if (autocomplete instanceof HTMLElement) {
  //             _autocomplete = new google.maps.places.Autocomplete(autocomplete)
  //             _autocomplete.bindTo('bounds', _map)
  //           }
  //         }
  //         let _infowindow = new google.maps.InfoWindow()
  //         if (typeof callback === 'function') {
  //           callback(_map, _marker, _autocomplete, _infowindow)
  //         }
  //       })
  //     })
  //   })
  // }

  // QuillEditor (target, options) {
  //   const maxRows = 10
  //   const maxCols = 5
  //   const tableOptions = []
  //   for (let r = 1; r <= maxRows; r++) {
  //     for (let c = 1; c <= maxCols; c++) {
  //       tableOptions.push('newtable_' + r + '_' + c)
  //     }
  //   }
  //   // Quill.register('modules/imageResize', ImageResize)
  //   let defaultToolbar = [
  //     [{table: tableOptions}, {table: 'append-row'}, {table: 'append-col'}],
  //     ['bold', 'italic', 'underline', 'strike'],
  //     ['blockquote', 'code-block'],
  //     [{'list': 'ordered'}, {'list': 'bullet'}],
  //     [{'script': 'sub'}, {'script': 'super'}],
  //     [{'indent': '-1'}, {'indent': '+1'}],
  //     [{'direction': 'rtl'}],
  //     [{'header': [1, 2, 3, 4, 5, 6, false]}],
  //     [{'color': []}, {'background': []}],
  //     [{'align': []}],
  //     ['link', 'image'],
  //     ['clean']
  //   ]
  //   // if (
  //   //   typeof options === 'object' &&
  //   //   options.hasOwnProperty('modules') &&
  //   //   options.modules.hasOwnProperty('toolbar')
  //   // ) {
  //   //   defaultToolbar = defaultToolbar.concat(options.modules.toolbar)
  //   // }
  //   let defaultOptions = {
  //     theme: 'snow',
  //     placeholder: 'Contenu...',
  //     modules: {
  //       toolbar: defaultToolbar,
  //       imageResize: {
  //         modules: ['Resize', 'DisplaySize', 'Toolbar'],
  //         handleStyles: {
  //           backgroundColor: 'black',
  //           border: 'none',
  //           color: 'white'
  //           // other camelCase styles for size display
  //         },
  //         displayStyles: {
  //           backgroundColor: 'black',
  //           border: 'none',
  //           color: 'white'
  //           // other camelCase styles for size display
  //         }
  //       },
  //       table: true
  //     }
  //   }
  //   let opt = Object.assign(defaultOptions, defaultOptions)
  //   import('quill').then(Quill => {
  //     const quillTable = require('quill-table')
  //     // Quill.register('modules/imageDrop', ImageDrop)
  //     Quill.register(quillTable.TableCell)
  //     Quill.register(quillTable.TableRow)
  //     Quill.register(quillTable.Table)
  //     Quill.register(quillTable.Contain)
  //     Quill.register('modules/table', quillTable.TableModule)
  //     this.each(el => {
  //       let editor = new Quill(el, opt)
  //       editor.on('text-change', (delta, oldDelta, source) => {
  //         if (source === 'user') {
  //           let $target = el.dataset.target || target
  //           if (typeof $target === 'string') {
  //             $target = document.querySelectorAll($target)
  //           }
  //           if ($target) {
  //             if ($target instanceof NodeList) {
  //               for (let $t of $target) {
  //                 if ($t instanceof HTMLInputElement) {
  //                   $t.value = el.querySelector('.ql-editor').innerHTML
  //                 } else if ($t instanceof HTMLElement) {
  //                   $t.innerHTML = el.querySelector('.ql-editor').innerHTML
  //                 }
  //               }
  //             }
  //             if (target instanceof HTMLInputElement) {
  //               target.value = el.querySelector('.ql-editor').innerHTML
  //             } else if (target instanceof HTMLElement) {
  //               target.innerHTML = el.querySelector('.ql-editor').innerHTML
  //             }
  //           }
  //         }
  //       })
  //     })
  //   })
  // }

  // timeago () {
  //   import('timeago.js').then(timeago => {
  //     timeago.register('fr_FR', require('timeago.js/locales/fr'))
  //     this.each(el => {
  //       timeago().render(el, 'fr_FR')
  //     })
  //   })
  // }

  // flatpickr (options) {
  //   let defaultOptions = Object.assign({
  //     enableTime: true,
  //     altInput: true,
  //     altFormat: 'j F Y, H:i',
  //     dateFormat: 'Y-m-d H:i:S'
  //   }, options)
  //   return this.each(el => {
  //     flatpickr(el, defaultOptions)
  //   })
  // }

  static exist(el) {
    return el !== null && el.length > 0
  }
}

export let app = selector => new DOM(selector)
